###
This controller is intended for non-changing callback URL's as proxy
###
class EaccountingStaticCallbackController extends AbstractController
	@register()
	@inject '$state',
		'$stateParams'
		'IntegrationService'
		'IntegrationRepository'
		'localStorageService'

	initialize: ->
		@integrationId = 'eaccounting'

		state = @localStorageService.get("auth.#{@integrationId}.state")
		@localStorageService.remove("auth.#{@integrationId}.state")

		if !state? || state != @$stateParams.state || !@$stateParams.code
			@goToIntegrationPage({error: 'no_token_redirect_uri'})

			return

		@IntegrationRepository
			.post(
				"#{@integrationId}/connect",
				{
					redirect_uri: @IntegrationService.getEaccountingRedirectUrl(),
					code: @$stateParams.code
				}
			)
			.then =>
				@goToIntegrationPage()
			.catch (response) =>
				console.error response

				@IntegrationRepository
					.getConfiguration(@integrationId)
					.then (response) =>
						error = {}

						if response.data.refresh_token
							error = {error: 'no_token_redirect_uri'}

						@goToIntegrationPage(error)
					.catch (innerResponse) =>
						console.error innerResponse

						@goToIntegrationPage({error: 'server_error'})

	goToIntegrationPage: (parameters = {}) ->
		@$state.go('integrations.integration.details', _.extend({action: 'config', id: @integrationId}, parameters))
